<script setup>
import {onMounted, ref} from "vue";
import {useBaseStore} from '@/stores/BaseStore';
import useHelper from "@/composables/useHelper";

const {languageCodeToFlagEmoji, setDocumentTitle, isMobile} = useHelper();

const showLanguages = ref(false);
const store = useBaseStore();

async function toggleLanguage(code) {
    store.setLoadingState(true);
    await store.setLanguage(code);
    updateDisplayedLanguageName();
    setDocumentTitle();
    showLanguages.value = false;
    await new Promise(resolve => setTimeout(resolve, 600));
    store.setLoadingState(false);
}

const displayedLanguageName = ref('');
let mobile = isMobile();

function updateDisplayedLanguageName() {
    const foundLanguage = store.allLanguages ? store.allLanguages.find(lang => lang.code === store.currentLanguage.code) : undefined;
    if (!foundLanguage && store.allLanguages) {
        setDefaultLanguage();
    }

    displayedLanguageName.value = store.currentLanguage.name;
}

function setDefaultLanguage() {
    store.setCurrentLanguage()
}

onMounted(async () => {
    if (!store.allLanguages.some(lang => lang.code === store.currentLanguage.code)) {
        setDefaultLanguage();
    }

    updateDisplayedLanguageName();
})
</script>

<template>
    <div class="group ml-4 flex items-center space-x-4 self-stretch">
        <div class=" relative flex cursor-pointer select-none items-center justify-center"
             @click="showLanguages = !showLanguages">
            <p class="text-sm font-medium text-gray-500" v-if="!mobile">{{ displayedLanguageName }}</p>
            <div class="flex h-3 w-3 items-center justify-center overflow-hidden mx-1">
                <!-- Arrow Icon here -->
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                     stroke="currentColor" class="h-3 w-3 object-contain">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5"/>
                </svg>
            </div>
            <div class="absolute -left-10 top-7  min-w-full  transition-all duration-300 ease-in-out z-50  "
                 v-show="showLanguages">
                <div class="mx-auto h-6 w-6 rotate-45 rounded-md bg-gray-100 shadow-lg shadow-gray-200"></div>
                <ul class="relative z-10 -mt-3 space-y-2 overflow-hidden rounded-md bg-gray-100 p-1 shadow-lg shadow-gray-200">
                    <li class="cursor-pointer" v-for="language in store.allLanguages" :key="language.code"
                        @click="toggleLanguage(language.code)">
                        <div class="flex items-center space-x-1.5 rounded px-4 py-2.5 pr-5 hover:bg-gray-200"
                             :class="{ 'bg-gray-200': language.name === store.currentLanguage.name }">
                            <p class="text-base font-medium capitalize text-gray-600">{{ language.name }}</p>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

